import centuryGothic from '../assets/gothic.ttf';

export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html {
            background: #005ec0;
        }
        body {
          background: url(${require(`../assets/background.jpg`)}) no-repeat;
          background-attachment: fixed;
          background-position-x: center;
          background-position-y: top;
          background-size: cover;
        }
        @media screen and (max-width: 468px) {
          body {
            background: url(${require(`../assets/backgroundp.jpg`)}) no-repeat;
            background-position-y: center;
            background-size: 100% 100%;
          }
        },
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }
        .games-filter-block {
          background: #000000c7;
        }
        .user-block {
          background: transparent;
          border: 1px solid #ffffffa3;
          border-radius: 4px;
          color: #white;
          padding-left: 4px;
          padding-right: 4px;
          width: 180px;
        }
        .user-block__value {
          font-weight: bold;
        }
        @font-face {
          font-family: 'CenturyGothic';
          src: url(${centuryGothic}) format('truetype');
          font-style: normal;
        }
      `,
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "rgba(0, 24, 54, 0.78)"
        }
      }
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(255, 194, 9)',
    },
    secondary: {
      main: 'rgb(255, 194, 9)',
    },
    toolbar: {
      main: 'rgb(255, 194, 9)',
    }
  },
}
